
import TsInput from '@/components/layout/Form/Input'

export default {
  components: {
    TsInput
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        code: null
      }
    }
  },
  methods: {
    async submit() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        this.$emit('submit', this.form)
      }
    }
  }
}
